import './routes';
import './stylesheets/jobDetailsWidget.styl';
import './stylesheets/taskStatusView.styl';
import './JobStatus';



// WEBPACK FOOTER //
// ./plugins/worker/web_client/main.js